<template>

</template>

<script>

  /**
   * Here is the service responsible for watching user location.
   *
   * It needs to be a proper Vue component in order to have access to the $store,
   * and to commit the new location each time it changes.
   */

  export default {
    name: 'watch-location',
    mounted() {
      console.log('Start watching user location...')
      this.watchUserLocation()
    },
    methods: {
      watchUserLocation() {
        if (navigator.geolocation) {
          // https://developer.mozilla.org/en-US/docs/Web/API/PositionOptions
          navigator.geolocation.watchPosition(this.success, this.error, {
            enableHighAccuracy: true,
          })
        } else {
          alert('Hum, it looks like your browser can\'t help us get your GPS position...')
        }
      },

      success(position) {
        console.log(' >>> watchLocation / watchPosition() / success / New user location')
        const { latitude, longitude } = position.coords

        // Push new location to store
        this.$store.commit('SET_USER_LOCATION', {
          lat: latitude,
          lng: longitude
        })

        this.$store.commit('SET_ERROR_MESSAGE', '')
      },

      error(errorMessage) {
        console.error(errorMessage)

        this.$store.commit('SET_ERROR_MESSAGE', errorMessage.message)

        // Possible errors:
        // - User denied Geolocation
        // - Origin does not have permission to use Geolocation service --> Needs to be https
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/services/watchLocation.vue